import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_RETURN_ORDERS, ADD_RETURN_ORDER
} from 'redux/actionTypes';
import { incrementIDGen, decrementProductQuantities, decrementVendorPayable } from '.';
import { returnOrder } from 'variables/idGenType';

export const getReturnOrders = () => (dispatch, getState) => {
  axiosClient
    .get('/api/returnOrders', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_RETURN_ORDERS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addReturnOrder = (newReturnOrder, userId) => (dispatch, getState) => {
  axiosClient
    .post('/api/returnOrders', newReturnOrder, tokenConfig(getState))
    .then(res => {
      const updatedProducts = res.data.products.map(product => ({
        id: product.productId,
        decrementQuantity: product.quantity
      }));

      dispatch(incrementIDGen({ id: userId, field: returnOrder }));
      dispatch(decrementProductQuantities(updatedProducts));
      if(!res.data.paymentByCash) dispatch(decrementVendorPayable({ id: res.data.vendorId, decrementAmount: res.data.total }));
      dispatch({
        type: ADD_RETURN_ORDER,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};